import { supabase } from '@/lib/supabase'

export type RoleChatPolicy = {
  role: string
  chat_enabled: boolean
}

export type PlanChatPolicy = {
  plan_id: string
  chat_enabled: boolean
}

export async function fetchRoleChatPolicies(): Promise<RoleChatPolicy[]> {
  const { data, error } = await supabase
    .from('role_chat_policies')
    .select('role,chat_enabled')
    .order('role', { ascending: true })

  if (error) throw error
  return (data || []) as RoleChatPolicy[]
}

export async function upsertRoleChatPolicy(role: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('role_chat_policies')
    .upsert({ role, chat_enabled: enabled }, { onConflict: 'role' })

  if (error) throw error
}

export async function fetchPlanChatPolicies(): Promise<PlanChatPolicy[]> {
  const { data, error } = await supabase
    .from('plan_chat_policies')
    .select('plan_id,chat_enabled')
    .order('plan_id', { ascending: true })

  if (error) throw error
  return (data || []) as PlanChatPolicy[]
}

export async function upsertPlanChatPolicy(planId: string, enabled: boolean): Promise<void> {
  const { error } = await supabase
    .from('plan_chat_policies')
    .upsert({ plan_id: planId, chat_enabled: enabled }, { onConflict: 'plan_id' })

  if (error) throw error
}
